import { Input } from 'antd';
import React, { Fragment } from 'react';
import { useForm } from 'react-antd-formutil';
import FormItem from 'components/FormItem';
import PwdRisk, { pwdLengthChecker, pwdTypeChecker } from 'components/PwdRisk';

const ConfirmPassword: React.FC = () => {
    const $formutil = useForm<{ login_password: string; confirm_password: string }>();
    const parser = (value, $setViewValue) => $setViewValue(value.trim());

    const onFieldChange = name => $formutil.$validate(name);

    const $validators = {
        isPassword: (value, prop, { validMessage: { isPassword } }) => pwdLengthChecker(value) || isPassword,
        isRisk: (value, prop, { validMessage: { isRisk } }) => pwdTypeChecker(value) || isRisk,
        isError: () => true
    };

    const validMessage = {
        required: __('Please enter your password'),
        isPassword: __('The password must be 8-24 characters long.'),
        isRisk: __('It must contain at least 3 of the following: letters, lowercase letters, numbers, or punctuation.')
    };

    // confirm password 只需要和 login password 是否一致
    const checkConfirmPassword = (confirmed, value) => {
        const confirmedValue = $formutil.$params[confirmed];

        if (!confirmedValue || !value) {
            return __('The password does not match.');
        }

        if (confirmedValue && value && value !== confirmedValue) {
            return __('The password does not match.');
        }

        return true;
    };

    const { login_password, confirm_password } = $formutil.$params;

    return (
        <Fragment>
            <FormItem
                name="login_password"
                isError
                isPassword
                isRisk
                required
                label={__('New Password')}
                $validators={$validators}
                validMessage={validMessage}
                $parser={parser}
                $onFieldChange={() => onFieldChange('confirm_password')}
                errorLevel="off">
                <Input.Password
                    type="password"
                    placeholder={__('Your password should be 8-24 characters')}
                    allowClear
                />
            </FormItem>
            <FormItem
                name="confirm_password"
                label={__('Confirm Password')}
                checker={val => checkConfirmPassword('login_password', val)}
                $parser={parser}
                $onFieldChange={() => onFieldChange('login_password')}
                errorLevel="off">
                <Input.Password type="password" placeholder={__('Please re-enter your password')} allowClear />
            </FormItem>
            <PwdRisk password={login_password} confirmPassword={confirm_password} />
        </Fragment>
    );
};

export default ConfirmPassword;
